var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaterHeaterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 52,
    viewBox: "0 0 37 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.71578 46.1797C6.77532 49.6096 12.7337 51.35 18.6345 51.35C24.5357 51.35 30.4944 49.6071 35.5541 46.1791L35.5653 46.1715L35.5759 46.1631C35.9092 45.8974 36.2069 45.4714 36.2069 44.9454V2.11111C36.2069 1.3058 35.551 0.65 34.7458 0.65H34.7453H2.52322C1.71791 0.65 1.06211 1.30584 1.06211 2.11111V44.9454C1.06211 45.4445 1.28248 45.8903 1.71578 46.1797ZM1.71578 46.1797C1.71547 46.1795 1.71515 46.1793 1.71484 46.1791L1.91124 45.8894L1.71711 46.1806C1.71667 46.1803 1.71622 46.18 1.71578 46.1797ZM33.2842 3.57221V44.1991C24.4175 49.8767 12.851 49.8767 3.98432 44.1991V3.57221H33.2842Z",
    fill: "url(#paint0_linear_3318_27502)",
    stroke: "url(#paint1_linear_3318_27502)",
    strokeWidth: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.638 37.0177C16.7531 37.0177 15.212 38.5587 15.212 40.4437C15.212 42.3286 16.7531 43.8697 18.638 43.8697C20.523 43.8697 22.064 42.3286 22.064 40.4437C22.064 38.5035 20.522 37.0177 18.638 37.0177ZM18.638 41.4621C18.0772 41.4621 17.6196 41.0045 17.6196 40.4437C17.6196 39.8829 18.0772 39.4252 18.638 39.4252C19.1988 39.4252 19.6564 39.8829 19.6564 40.4437C19.6564 41.0045 19.1988 41.4621 18.638 41.4621Z",
    fill: "url(#paint2_linear_3318_27502)",
    stroke: "url(#paint3_linear_3318_27502)",
    strokeWidth: 0.185339
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8831 24.452L23.8833 24.4521L23.889 24.4414C24.8374 22.665 24.7771 20.6439 23.7106 18.925L23.7106 18.925L23.7086 18.9217L19.9304 12.9779L19.9304 12.9778L19.9268 12.9724C19.6366 12.5343 19.1894 12.3165 18.691 12.3165C18.1913 12.3165 17.7452 12.5373 17.4558 12.9715L17.4557 12.9715L17.4516 12.9779L13.6734 18.9217L13.6734 18.9217L13.6715 18.9248C12.6102 20.633 12.4853 22.6577 13.4938 24.4432C14.449 26.2871 16.4622 27.4608 18.6367 27.4608H18.6367C20.8171 27.4608 22.8225 26.2828 23.8831 24.452ZM15.9415 22.9917C15.5121 22.23 15.5486 21.31 16.0469 20.4598L18.6367 16.4241L21.2294 20.4641C21.7199 21.2509 21.7673 22.1717 21.3267 23.0012L21.3262 23.0023C20.8402 23.9248 19.8599 24.482 18.6368 24.482C17.4237 24.482 16.4858 23.932 15.9415 22.9917Z",
    fill: "url(#paint4_linear_3318_27502)",
    stroke: "url(#paint5_linear_3318_27502)",
    strokeWidth: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3318_27502",
    x1: 32.2121,
    y1: 1.93812,
    x2: -3.56989,
    y2: -12.6987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3318_27502",
    x1: 32.2121,
    y1: 1.93812,
    x2: -3.56989,
    y2: -12.6987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3318_27502",
    x1: 21.2659,
    y1: 37.2354,
    x2: 15.289,
    y2: 33.6864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3318_27502",
    x1: 21.2659,
    y1: 37.2354,
    x2: 15.289,
    y2: 33.6864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3318_27502",
    x1: 23.0382,
    y1: 12.9375,
    x2: 11.9267,
    y2: 7.88753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3318_27502",
    x1: 23.0382,
    y1: 12.9375,
    x2: 11.9267,
    y2: 7.88753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterHeaterIcon);
export default __webpack_public_path__ + "static/media/water_heater_icon.4a81cbe285c79d5c3bce49b2dd054df2.svg";
export { ForwardRef as ReactComponent };